import React, { FC } from 'react';
import { MenuItemConfig } from 'uitk-react-menu';
import { LanguageItemFragment } from 'src/graphql/__generated__/types';
import { useLocation } from 'react-router-dom';
import { ViewLarge, Viewport, ViewSmall } from '@shared-ui/viewport-context';
import LanguageSelectorMobile from 'components/page-header/mobile/language-selector-mobile';
import LanguageSelectorDesktop from 'components/page-header/desktop/language-selector-desktop';

interface LanguageSelectorProps {
  languages: Array<LanguageItemFragment>;
  leadingIcon?: string;
  trailingIcon?: string;
}

const LanguageSelector: FC<LanguageSelectorProps> = ({ languages, leadingIcon, trailingIcon }) => {
  const location = useLocation();
  const currentLanguage = languages.filter((language) => language.icon !== null)[0];

  const getLanguageMenuItem = (language: LanguageItemFragment): MenuItemConfig => ({
    className: 'uitk-list-item',
    label: language.title,
    typeAnchor: true,
    attributes: {
      role: 'menuItem',
    },
    selected: language.title === currentLanguage.title,
    href: `${location.pathname}?locale=${language.label}`,
  });

  const languageMenuItems = languages.map((language) => getLanguageMenuItem(language));

  return (
    <Viewport>
      <ViewSmall>
        <LanguageSelectorMobile languageMenuItems={languageMenuItems} iconName={leadingIcon} />
      </ViewSmall>
      <ViewLarge>
        <LanguageSelectorDesktop
          languageMenuItems={languageMenuItems}
          currentLanguage={currentLanguage}
          primaryIconName={leadingIcon}
          secondaryIconName={trailingIcon}
        />
      </ViewLarge>
    </Viewport>
  );
};
export default LanguageSelector;
